import React from "react";
import PricingTable from "./PricingTable";
import BoldCell from "./BoldCell";
import Tick from "../Tick";

const AlwaysIncludedTable: React.FC = ({ ...props }) => {
  return (
    <PricingTable>
      <tbody>
        <tr>
          <BoldCell>On-demand preview environments</BoldCell>
          <td>
            <Tick/>
          </td>
        </tr>
        <tr>
          <BoldCell>30 days of infrastructure metrics</BoldCell>
          <td>
            <Tick/>
          </td>
        </tr>
        <tr>
          <BoldCell>15 minutes of continuous profiling</BoldCell>
          <td>
            <Tick/>
          </td>
        </tr>
        <tr>
          <BoldCell>Real-time billing estimates in your dashboard</BoldCell>
          <td>
            <Tick/>
          </td>
        </tr>
        <tr>
          <BoldCell>DDoS protection</BoldCell>
          <td>
            <Tick/>
          </td>
        </tr>
        <tr>
          <BoldCell>Let's Encrypt TLS certificates</BoldCell>
          <td>
            <Tick/>
          </td>
        </tr>
      </tbody>
    </PricingTable>
  );
};

export default AlwaysIncludedTable;
